import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
// @mui
import { Container } from "@mui/material";
// components
import { Loader } from "..";
import SideNav from "./SideNav";
import TitleBar from "./TitleBar";
// constants
import { APP_ROUTES } from "../../common/constants";
// hooks
import useLocales from "../../hooks/useLocales";
import { Box } from "@shopify/polaris";

const PRODUCTS_SIDE_NAV_CONFIG = [
  {
    to: APP_ROUTES.NOTIFICATIONS.PREORDERS.ROOT,
    icon: "mdi:cart-check",
    title: "nav.pre-orders",
    subItems: [
      { to: APP_ROUTES.NOTIFICATIONS.PREORDERS.EMAIL, title: "common.email" },
      { to: APP_ROUTES.NOTIFICATIONS.PREORDERS.SMS, title: "common.sms" },
      { to: APP_ROUTES.NOTIFICATIONS.PREORDERS.SHIPPING_EMAIL, title: "common.shipping" },
    ],
  },
  {
    to: APP_ROUTES.NOTIFICATIONS.BACKINSTOCK.ROOT,
    icon: "icon-park-outline:timer",
    title: "nav.back-in-stock",
    subItems: [{ to: APP_ROUTES.NOTIFICATIONS.BACKINSTOCK.EMAIL, title: "common.email" }],
  },
];

const NotificationsLayout = () => {
  const { translate } = useLocales();
  const { pathname } = useLocation();

  const HEADINGS = {
    [APP_ROUTES.NOTIFICATIONS.PREORDERS.EMAIL]: `${translate("nav.sub.pre-orders")} / ${translate("common.email")}`,
    [APP_ROUTES.NOTIFICATIONS.PREORDERS.SMS]: `${translate("nav.sub.pre-orders")} / ${translate("common.sms")}`,
    [APP_ROUTES.NOTIFICATIONS.PREORDERS.SHIPPING_EMAIL]:
      `${translate("nav.sub.pre-orders")} / ${translate("common.shipping")}`,
    [APP_ROUTES.NOTIFICATIONS.BACKINSTOCK.EMAIL]: `${translate("common.back-in-stock")} / ${translate("common.email")}`,
  };

  return (
    <Container maxWidth="xl">
      <Box paddingInline={{ xs: "400", sm: "0" }}>
        <TitleBar
          heading={HEADINGS[pathname] || ""}
          breadcrumb={{ name: translate("nav.sub.notifications"), href: APP_ROUTES.NOTIFICATIONS.ROOT }}
        />

        <SideNav items={PRODUCTS_SIDE_NAV_CONFIG} />

        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </Box>
    </Container>
  );
};

export default NotificationsLayout;
